import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traduções gerais
import enTranslation from './locales/en/translation.json';
import ptTranslation from './locales/pt/translation.json';
import esTranslation from './locales/es/translation.json';

// Catálogo separado
import enCatalog from './locales/en/catalog.json';
import ptCatalog from './locales/pt/catalog.json';
import esCatalog from './locales/es/catalog.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          ...enTranslation,
          ...enCatalog
        }
      },
      pt: {
        translation: {
          ...ptTranslation,
          ...ptCatalog
        }
      },
      es: {
        translation: {
          ...esTranslation,
          ...esCatalog
        }
      }
    },
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false
    }
  });

async function loadKeys() {

 await fetch('https://hgpedea.sema.ce.gov.br/gestor-api/getRotulosBilingue')
    .then(res => res.json())
    .then(data => {
      data.forEach(item => {
        // Usa a chave 'key' para o path no catálogo
        const translationKey = item.key;

       

        // Adiciona ou sobrescreve as traduções dinamicamente:
        i18n.addResource('pt', 'translation', translationKey, item.pt);
        i18n.addResource('en', 'translation', translationKey, item.en);
        i18n.addResource('es', 'translation', translationKey, item.es);


      });

      i18n.changeLanguage(i18n.language);

    })
    .catch(err => {
      console.error('Erro ao carregar rótulos bilíngues', err);
    });

}

await loadKeys();

export default i18n;
